import { Outlet } from "react-router-dom";
import TopBar from "../top-bar";

const UnauthenticatedDashboardLayout = () => {
  return (
    <div id="dashboard-wrapper" className="bg-background">
      <TopBar.Main variant="secondary">
        <TopBar.NavItems>
          <TopBar.NavItem
            href="https://venturous.work/about"
            title="About"
            externalLink
            variant="secondary"
          />
          <TopBar.NavItem
            href="https://venturous.work/percipio-case-study"
            title="Case Studies"
            externalLink
            variant="secondary"
          />
          <TopBar.NavItem
            href="https://venturous.work/blog"
            title="Blog"
            externalLink
            variant="secondary"
          />
        </TopBar.NavItems>
        <TopBar.UnauthedControls />
        <TopBar.Sidebar variant="secondary" />
      </TopBar.Main>
      <main className="px-6 h-[calc(100vh-64px)] overflow-auto flex flex-col">
        <Outlet />
      </main>
    </div>
  );
};

export default UnauthenticatedDashboardLayout;
